import ComponentsFactory from 'foundation/components-factory';
import FeaturesCarousel from './js/features-carousel.component';
import './scss/index.scss';

ComponentsFactory.getInstance().define('features-carousel', FeaturesCarousel);
